import { LegalCaseTypeActions } from './actions'
import { LegalCaseTypeGetters } from './getters'
import { LegalCaseTypeMutations } from './mutations'
import { LegalCaseTypeState } from './state'

export const LEGAL_CASE_TYPE_NAMESPACE = 'legalCaseType'

export const LegalCaseType = {
  namespaced: true,
  state: LegalCaseTypeState,
  actions: LegalCaseTypeActions,
  mutations: LegalCaseTypeMutations,
  getters: LegalCaseTypeGetters,
}
